module.exports = __webpack_public_path__ + "static/img/gg.ec290fee.svg";